// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

const clearUserSession = () => {
  localStorage.removeItem('user_token');
  localStorage.removeItem('user_data');
  localStorage.removeItem('user_login_time');
};

const clearAdminSession = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
  localStorage.removeItem('admin_login_time');
};

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const adminToken = localStorage.getItem('admin_token');
  const userToken = localStorage.getItem('user_token');

  if (adminOnly) {
    if (!adminToken) return <Navigate to="/admin/login" replace />;

    // Check 3-day admin token age
    const adminLoginTime = parseInt(localStorage.getItem('admin_login_time') || '0');
    if (adminLoginTime && Date.now() - adminLoginTime > THREE_DAYS_MS) {
      clearAdminSession();
      return <Navigate to="/admin/login" replace />;
    }

    return children;
  }

  if (!adminToken && !userToken) {
    return <Navigate to="/login" replace />;
  }

  if (userToken && !adminToken) {
    // Check 3-day user token age
    const userLoginTime = parseInt(localStorage.getItem('user_login_time') || '0');
    if (userLoginTime && Date.now() - userLoginTime > THREE_DAYS_MS) {
      clearUserSession();
      return <Navigate to="/login" replace />;
    }

    // Check plan expiration
    try {
      const userData = JSON.parse(localStorage.getItem('user_data') || 'null');
      if (userData?.plan_end_date) {
        const planEndDate = new Date(userData.plan_end_date);
        if (new Date() > planEndDate || !userData.is_plan_active) {
          clearUserSession();
          return <Navigate to="/login" replace />;
        }
      }
    } catch {
      clearUserSession();
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
